import React, {useEffect} from 'react';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

interface SweetAlertProps {
  title: string;
  text?: string
  danger?: boolean;
  success?: boolean;
  showConfirm?: boolean;
  showCancel?: boolean;
  confirmBtnBsStyle?: string;
  cancelBtnBsStyle?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  closeOnConfirm?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export const SweetAlert: React.FC<SweetAlertProps> = ({
  title,
  text = '',
  danger,
  success,
  showConfirm = true,
  showCancel = false,
  confirmBtnBsStyle,
  cancelBtnBsStyle,
  confirmBtnText = 'OK',
  cancelBtnText = 'Cancel',
  closeOnConfirm = true,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    const icon: SweetAlertIcon = danger ? 'error' : success ? 'success' : 'info';

    MySwal.fire({
      title,
      text,
      icon,
      showConfirmButton: showConfirm,
      showCancelButton: showCancel,
      confirmButtonText: confirmBtnText,
      cancelButtonText: cancelBtnText,
      buttonsStyling: true,
      customClass: {
        confirmButton: confirmBtnBsStyle ? `btn btn-${confirmBtnBsStyle}` : undefined,
        cancelButton: cancelBtnBsStyle ? `btn btn-${cancelBtnBsStyle}` : undefined,
      },
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm?.();
        if (closeOnConfirm) MySwal.close();
      } else if (result.isDismissed) {
        onCancel?.();
      }
    });
  }, []);

  useEffect(() => {
    if (Swal.isVisible()) {
      MySwal.update({
        text: text,
      });
    }
  }, [text]);

  return null;
};
